import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { getSeoFooter } from '../../../../redux/actions/seo-footer'
import SeoFooter from '../../../../components/seo-footer'
import { SeoFooterWrapper } from './mixins'

interface HomeSeoFooterProps {
  success: boolean
}

const HomeSeoFooter = ({ success }: HomeSeoFooterProps) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getSeoFooter())
  }, [])

  return success ? (
    <SeoFooterWrapper>
      <SeoFooter />
    </SeoFooterWrapper>
  ) : null
}

const states = ({ seoFooterStore }) => ({
  success: seoFooterStore.success,
})

export default connect(states)(HomeSeoFooter)
